import { FormattedMessage } from 'react-intl';

export const templates = [
  {
    id: '1',
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.chooseSources.marcTemplates.label.libCat"
        defaultMessage="Libraries catalogs"
      />
    ),
    icon: 'document',
    description: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.chooseSources.marcTemplates.desc.libCat"
        defaultMessage="Import from external libraries catalogs like library of congress by Z39.50 server"
      />
    ),
    active: true,
    url: '/inventory/copycat/search',
  },
  {
    id: '2',
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.chooseSources.marcTemplates.label.digitalRepos"
        defaultMessage="Digital repositories"
      />
    ),
    icon: 'document',
    description: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.chooseSources.marcTemplates.desc.digitalRepos"
        defaultMessage="Import from external digital repositories like Dspace"
      />
    ),
    active: false,
  },
  {
    id: '3',
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.chooseSources.marcTemplates.label.localImport"
        defaultMessage="Local import"
      />
    ),
    icon: 'document',
    description: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.chooseSources.marcTemplates.desc.localImport"
        defaultMessage="Import MARC record from your local desktop"
      />
    ),
    active: false,
  },
];
